module.exports = __webpack_public_path__ + "img/lightbulb-off-fill.5c095399.svg";